import { Box, styled } from '@mui/material';

export interface IStyledGridContainerProps {
  itemsLength: number;
  columns: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
  };
}

export const StyledGridContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'itemsLength' && prop !== 'columns',
})<IStyledGridContainerProps>(({ theme, itemsLength, columns }) => ({
  display: 'grid',
  rowGap: theme.spacing(0.5),
  columnGap: theme.spacing(2),
  gridAutoFlow: 'column',
  width: '100%',
  gridTemplateColumns: `repeat(${columns.xs}, 1fr)`,
  gridTemplateRows: `repeat(${Math.ceil(itemsLength / columns.xs)}, 1fr)`,
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: `repeat(${columns.sm}, 1fr)`,
    gridTemplateRows: `repeat(${Math.ceil(itemsLength / columns.sm)}, 1fr)`,
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: `repeat(${columns.md}, 1fr)`,
    gridTemplateRows: `repeat(${Math.ceil(itemsLength / columns.md)}, 1fr)`,
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: `repeat(${columns.lg}, 1fr)`,
    gridTemplateRows: `repeat(${Math.ceil(itemsLength / columns.lg)}, 1fr)`,
  },
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: `repeat(${columns.xl}, 1fr)`,
    gridTemplateRows: `repeat(${Math.ceil(itemsLength / columns.xl)}, 1fr)`,
  },
}));
